export * from './extra-vereinbarung-post-request.interface';
export * from './extra-vereinbarung-post-response.interface';
export * from './extra-vereinbarung-post.shapes';
